// Remembers the last org the person opened, so "/" takes them back to it. Browser storage can be unavailable
// (private windows, blocked storage); then we simply open their first org.

const KEY = 'rowcall:last-org'

export const readLastOrgSlug = (): string | null => {
  try {
    return window.localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export const rememberOrgSlug = (slug: string): void => {
  try {
    window.localStorage.setItem(KEY, slug)
  } catch {
    // storage blocked: nothing to remember
  }
}
